import { BugoDetailContainer } from "@/containers/BugoContainer/BugoDetailContainer/BugoDetailContainer";
import { GetServerSideProps } from "next";
import { getObituariesVisitorVersion } from "@/apis/obituaries";
import { getCdnImageSrc } from "goi_common";
import { useCustomVariation } from "@/hooks/useCustomVariation";

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  const data = await getObituariesVisitorVersion(
    query?.sangjuKey as string,
    query?.temporary_key as string | undefined
  );
  const obituary = data?.obituary;

  const title =
    obituary?.name && obituary?.die_term
      ? `[부고] ${obituary.name} 님께서 ${
          obituary.die_term ?? "별세"
        }하셨기에 부고를 알려드립니다.`
      : "[부고] 알려드립니다.";

  const description = data?.name
    ? `${data?.name} 님으로부터 부고장이 도착했습니다.`
    : "부고장이 도착했습니다.";

  return {
    props: {
      pageOgTitle: title,
      pageDescription: description,
      pageOgImage: `${getCdnImageSrc("bugo/bugo_kakao_share.png")}`,
    },
  };
};

const ShareVisitorPage = () => {
  useCustomVariation(6);
  return <ShareVisitorContainer />;
};

const ShareVisitorContainer = () => {
  return <BugoDetailContainer shouldEdit={false} isVisitorType />;
};

export default ShareVisitorPage;
